<template>
  <vs-table hover-flat v-if="members && members.length" :data="members">
    <template slot="thead">
      <vs-th v-text="$t('caller_company_name')"></vs-th>
      <vs-th v-text="$t('name')"></vs-th>
      <vs-th v-text="$t('join_now')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="tr.company_name" :data-tr-title="$t('caller_company_name')"></vs-td>
        <vs-td v-text="tr.name" :data-tr-title="$t('name')"></vs-td>
        <vs-td v-text="tr.created_at" :data-tr-title="$t('join_now')"></vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-user" size="small" @click="$emit('selectMember', tr.id)"></vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Consultations.Consultations.SelectMembers',
  props: {
    members: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
